module.exports = __webpack_public_path__ + "img/btn2.c3f361d4.png";